import Radio from "backbone.radio";
import { useEffect } from "react";
import { toast } from "extensions/toast";

import { store } from "common/store";

import { ReportsPage } from "administrator/features/reports/reports";

import { REPORTS_UPDATE_STATE_FROM_URL } from "common/actions/reports";

import { Switch, AuthRoute, useRouteMatch, Redirect, useParams } from "extensions/react-router";

export function ReportsRouter() {
    const { url } = useRouteMatch();
    return (
        <Switch>
            {/* TODO MATT: get the rest of parameters in URL to forward */}
            <AuthRoute
                path={`${url}/reports/prod_support_all_op_incidents`}
                render={({ match }) => match
                        && toast.warning("You are using outdated URL format. Please update your links & bookmarks to the new format")
                        && <Redirect to={`${url}/reports/prod_support__all_op_incidents${match.params?.qualifiers ? `/${match.params.qualifiers}` : ""}`}/>}
            />
            <AuthRoute path={`${url}/reports/:id?/:qualifiers?`} component={ReportsComponent} />
            <AuthRoute
                path={`${url}/reports/:qualifiers?`}
                render={({ match }) => match
                        && toast.warning("You are using outdated URL format. Please update your links & bookmarks to the new format")
                        && <Redirect to={`${url}/administrator/reports`}/>}
            />
        </Switch>
    );
}

function ReportsComponent() {
    const { id, qualifiers } = useParams();

    useEffect(() => {
        store.dispatch(REPORTS_UPDATE_STATE_FROM_URL({ id, qualifiers }));
        
        Radio.channel("main").request("show:app:view", <ReportsPage />, {
            hideDatePicker: true,
            name: "Reports"
        });
    }, [id, qualifiers]);

    return null;
}
